import React from "react";
import { FaWhatsapp, FaExclamationTriangle } from "react-icons/fa";

export default function ReturnPolicy() {
  const brandGreen = "#1ac942";
  const glowStyle = "0 8px 30px rgb(26 201 66 / 33%)";

  return (
    <section style={{ 
      padding: "60px 20px", 
      backgroundColor: "black", 
      color: "whitesmoke", 
      fontFamily: "Inter, Arial, sans-serif",
      minHeight: "100vh" 
    }}>
      <div style={{ 
        maxWidth: "850px", 
        margin: "0 auto", 
        color: 'whitesmoke',
        borderRadius: "15px",
        boxShadow: glowStyle,
        border: "1px solid #1b5e20",
        padding: "40px 30px",
        backgroundColor: "#050505"
      }}>
        
        <h1 style={{ 
          fontSize: "42px", 
          fontWeight: "800", 
          marginBottom: "16px", 
          color: "whitesmoke", 
          textAlign: "center" 
        }}>
          Return & Refund Policy
        </h1>

        {/* IMPORTANT ALERT FOR VIDEO */}
        <div style={{ 
          backgroundColor: "rgba(26, 201, 66, 0.1)", 
          border: `1px dashed ${brandGreen}`, 
          padding: "20px", 
          borderRadius: "8px", 
          marginBottom: "30px",
          display: "flex",
          alignItems: "flex-start",
          gap: "15px"
        }}>
          <FaExclamationTriangle style={{ color: brandGreen, fontSize: "24px", marginTop: "4px" }} />
       <p style={{ margin: 0, fontSize: "15px", lineHeight: "1.6" }}>
  <strong>IMPORTANT:</strong> In case of a damaged or incorrect product, please 
  <strong> share an unboxing video and clear images on our WhatsApp</strong>. 
  Refund or replacement requests will <strong>not be processed without valid video proof</strong>.
</p>
        </div>

        <h3 style={styles.heading}>Return Policy</h3>
        <p style={styles.text}>
          Due to the nature of herbal wellness supplements like <strong>BioSurge</strong>,
          returns or exchanges are accepted <strong>only in cases of damaged, defective,
          or incorrect products</strong> delivered to you. For safety, hygiene, and quality
          reasons, opened or used products are <strong>non-returnable and non-exchangeable</strong>.
        </p>

        <h3 style={styles.heading}>Return / Exchange Duration and Eligibility</h3>
        <p style={styles.text}>
          To be eligible for a return or exchange, you must notify us within
          <strong> 7 days of delivery</strong> in case of a damaged or incorrect BioSurge
          product. Requests made after this period will not be accepted. All returned
          items are subject to inspection before approval.
        </p>

        <h3 style={styles.heading}>Return & Exchange Conditions</h3>
        <p style={styles.text}>
          Products must be returned in their original, unopened packaging and in the same
          condition as delivered. Any return or exchange request will be processed only
          after our quality team verifies and approves the returned BioSurge product.
        </p>

        <h3 style={styles.heading}>How to Initiate a Return or Exchange</h3>
        <p style={styles.text}>
          To initiate a return or exchange, please contact us through our
          <strong> Contact Page</strong> or email or whatsapp us at:
          <a href="mailto:biosurge01@gmail.com" style={styles.link}>
            biosurge01@gmail.com
          </a>
          <a 
            href="https://api.whatsapp.com/send/?phone=917992151205&text=Hi+BioSurge%21+I+want+to+report+a+damage/wrong+product+delivery.+I+have+the+video+proof." 
            target="_blank"
            rel="noreferrer"
            style={{ ...styles.link, marginLeft: "20px", display: "inline-flex", alignItems: "center", gap: "8px" }}
          >
            <FaWhatsapp size={20} color={brandGreen} /> WhatsApp Support
          </a>
        </p>

        <h3 style={styles.heading}>Return Shipping Details</h3>
        <p style={styles.text}>
          Customers are responsible for return shipping costs unless the product received
          is damaged or incorrect. Once the returned item is received and inspected,
          the approved refund or replacement process will begin.
        </p>

        <h3 style={styles.heading}>Refund Policy</h3>
        <p style={styles.text}>
          After successful inspection and approval, refunds will be processed to the
          original payment method used during purchase. Refund timelines may vary based
          on your bank or payment provider.
          <br/><br/>
          Refund timeline: 5–7 business days after approval
        </p>

        <h3 style={styles.heading}>Exchange Policy</h3>
        <p style={styles.text}>
          Exchanges are applicable only for damaged or incorrect BioSurge products
          reported within 7 days of delivery. Upon approval, a replacement product
          will be dispatched at the earliest.
        </p>

      </div>
    </section>
  );
}

const styles = {
  heading: {
    fontSize: "22px",
    fontWeight: "700",
    marginTop: "35px",
    marginBottom: "12px",
    color: "whitesmoke",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.7",
    color: "#ccc"
  },
  link: {
    color: "#1ac942",
    marginLeft: "6px",
    textDecoration: "underline",
    fontWeight: "600"
  }
};